<template>
  <we-panel diretion="horizontal" class="panelContainer">
    <we-panel-item :index="1" class="left-panel">
      <we-panel diretion="vertical" class="panelContainer">
        <we-panel-item
          ref="topPanel"
          :index="1"
          :min="100"
          class="editor-panel"
        >
          <editor
            ref="editor"
            :script="script"
            :work="work"
            :script-type="work.type"
            @on-save="saveTotalContent"
            @showConfig="
              () => {
                this.$refs.config.handleconfigToggle();
              }
            "
            @getSourceId="getSourceId"
            @getValideSQLFn="getValideSQLFn"
            @getResult="getResult"
          />
          <Spin v-if="saveLoading" size="large" class="new-sidebar-spin" fix />
        </we-panel-item>
        <we-panel-item
          ref="bottomPanel"
          :index="2"
          :height="scriptViewState.bottomPanelHeight"
          :min="32"
          class="log-panel"
          v-if="show"
          @on-change="changeBottomPanel"
        >
          <div class="workbench-tabs">
            <div class="workbench-tab-wrapper">
              <div class="workbench-tab">
                <div
                  class="workbench-tab-item active"
                  @click="showPanelTab('testResult')"
                >
                  <span>测试结果</span>
                </div>
              </div>
              <div class="workbench-tab-button">
                <Dropdown
                  trigger="click"
                  placement="bottom-end"
                  transfer
                  @on-click="configLogPanel"
                >
                  <Icon type="md-list" />
                  <DropdownMenu slot="list">
                    <DropdownItem name="fullScreen" v-if="!isBottomPanelFull">{{
                      $t("message.constants.logPanelList.fullScreen")
                    }}</DropdownItem>
                    <DropdownItem name="releaseFullScreen" v-else>{{
                      $t("message.constants.logPanelList.releaseFullScreen")
                    }}</DropdownItem>
                    <DropdownItem
                      name="min"
                      v-if="!scriptViewState.bottomPanelMin"
                      >{{
                        $t("message.constants.logPanelList.min")
                      }}</DropdownItem
                    >
                    <DropdownItem name="releaseMin" v-else>{{
                      $t("message.constants.logPanelList.releaseMin")
                    }}</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
            <div class="workbench-container">
              <testResult-com
                :height="scriptViewState.cacheBottomPanelHeight"
                ref="result"
                :result="result"
              />
            </div>
          </div>
        </we-panel-item>
      </we-panel>
    </we-panel-item>
    <we-panel-item
      :index="2"
      :width="60"
      :min="60"
      :max="80"
      class="right-panel"
    >
      <configure-com
        class="right"
        ref="config"
        :params="script.params"
        @handleSave="handleSave"
        :valideSQLFn="valideSQLFn"
        :disabled="script.readOnly"
      />
    </we-panel-item>
  </we-panel>
</template>
<script>
import { isEmpty } from "lodash";
import { Script } from "../modal.js";
import editor from "./editor.vue";
import TestResult from "./result.vue";
import Configure from "./configure.vue";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  components: {
    editor,
    "testResult-com": TestResult,
    "configure-com": Configure,
  },
  props: {
    work: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      script: {},
      scriptViewState: {
        showPanel: "result",
        height: 0,
        bottomPanelHeight: 0,
        cacheBottomPanelHeight: 0,
        bottomPanelMin: false,
        cacheLogScroll: 0,
      },
      biLoading: false,
      saveLoading: false,
      isLogShow: true,
      autoSaveTimer: null,
      isBottomPanelFull: false,
      show: false, //是否已经过测试显示测试结果
      valideSQLFn: () => {},
      result: {},
    };
  },
  computed: {
    isPanelMin() {
      if (!this.script) return null;
      const emptyResult = !this.script.result || isEmpty(this.script.result);
      return emptyResult;
    },
  },
  watch: {
    "script.data": function () {
      if (!this.work.ismodifyByOldTab) {
        this.work.unsave = this.script.data != this.script.oldData;
      }
    },
    "script.oldData": function () {
      if (!this.work.ismodifyByOldTab) {
        this.work.unsave = this.script.data != this.script.oldData;
      }
    },
    isPanelMin: function (val) {
      if (val) {
        this.configLogPanel("min");
      } else {
        this.configLogPanel("releaseMin");
      }
    },
  },

  async created() {
    this.userName = this.getUserName();
    // 如果当前work存在data，表示工作已经被打开
    if (this.work.data) {
      delete this.work.data.oldData;
      this.script = this.work.data;
    } else {
      let supportedMode = {
        rule: /(新建接口)/i,
        lang: "hql",
        executable: true,
        application: "spark",
        runType: "sql",
        ext: ".sql",
        scriptType: "hive",
        abbr: "sql",
        logo: "fi-hive",
        isCanBeNew: true,
        label: "Sparksql",
        isCanBeOpen: true,
        flowType: "sparksql",
      };

      this.work.data = this.script = new Script(
        Object.assign(supportedMode, {
          id: this.work.id,
          fileName: this.work.filename,
          copy: this.work.copy,
          data: this.work.code,
          params: this.work.params,
          flowStatus: this.work.flowStatus,
          readOnly: this.work.flowStatus === 0 ? true : false,
        })
      );
    }
    // 删掉无用的code和params，因为已经存储在script对象中
    delete this.work.code;
    delete this.work.params;
    this.script.oldData = this.script.data;
    this.script.validateSQL = this.script.data; //已验证过的SQL
  },
  methods: {
    getResult(obj) {
      //获取测试结果
      obj.time = moment().format("YYYY-MM-DD HH:mm:ss");
      this.result = obj;
      if (!this.show) {
        this.show = true;
      }
    },
    "Workbench:updateScript"({ params, flowStatus, copy, id }, cb) {
      if (id == this.script.id) {
        if(id!=params.define.id){
          this.script.id = params.define.id + '';
        }
        this.script.params = params;
        this.script.flowStatus = flowStatus;
        this.script.copy = copy;
        this.script.oldData = this.script.data;
        this.script.readOnly = flowStatus === 0 ? true : false;
        cb && cb(true);
      }
    },
    "Workbench:setEditorPanelSize"(option) {
      if (option.id === this.script.id) {
        this.$refs.topPanel[option.status]({
          isDiy: true,
          diyStyle: {
            top: "33px",
            right: 0,
            bottom: 0,
            left: 0,
          },
        });
      }
    },

    configLogPanel(name) {
      if (name == "fullScreen") {
        this.isBottomPanelFull = true;
        this.$refs.bottomPanel[name]({
          isDiy: false,
        });
      }
      if (name == "releaseFullScreen") {
        this.isBottomPanelFull = false;
        this.$refs.bottomPanel[name]({
          isDiy: false,
        });
      }
      if (name == "min") {
        this.scriptViewState.bottomPanelHeight = 32;
        console.log(this.scriptViewState.bottomPanelHeight);
        this.scriptViewState.bottomPanelMin = true;
      }
      if (name == "releaseMin") {
        this.scriptViewState.bottomPanelHeight =
          this.scriptViewState.height * 0.4;
        this.scriptViewState.bottomPanelMin = false;
      }
    },
    changeBottomPanel({ height }) {
      this.scriptViewState.cacheBottomPanelHeight = height;
    },

    handleSave(type, cb) {
      let { id, name, parentId } = this.script.params.define;
      if (id && this.work.filename != name) {
        this.dispatch(
          "Workbench:checkExist",
          { pId: parentId, filename: name },
          (status) => {
            if (typeof cb === "function") {
              cb(status);
            }
            if (status) {
              this.$Message.warning("该接口名在此文件夹中已存在");
              return;
            }
          }
        );
      }
      if (!id) {
        if (type === "saveAs") {
          //新建，点击的是编辑器的保存
          this.$Modal.confirm({
            title: this.$t(
              "message.workBench.body.script.script.confirmModal.title"
            ),
            content: this.$t(
              "message.workBench.body.script.script.confirmModal.content"
            ),
            okText: this.$t(
              "message.workBench.body.script.script.confirmModal.okText"
            ),
            cancelText: this.$t(
              "message.workBench.body.script.script.confirmModal.cancelText"
            ),
            onOk: () => {
              this.dispatch("Workbench:saveAs", this.script, (status) => {
                if (typeof cb === "function") {
                  cb(status);
                }
              });
            },
          });
        } else {
          this.$emit("updateApiName", name);
          if (typeof cb === "function") {
            cb(false);
          }
        }
      } else {
        this.saveLoading = true;
        this.dispatch("Workbench:save", { script: this.script }, (status) => {
          if (status) {
            this.saveLoading = false;
            if (typeof cb === "function") {
              cb(true);
            }
          }
        });
      }
    },
    saveTotalContent(cb) {
      //点击编辑器的保存或者测试前的保存
      this.$refs.config.clickSave("saveAs", cb);
    },
    getSourceId(dataSourceId) {
      this.$emit("getSourceId", dataSourceId);
    },
    getValideSQLFn(fn) {
      //获取验证SQL的函数
      this.valideSQLFn = fn;
    },
  },
};
</script>
